export default "<p>\n  my-page works!\n</p>\n";